import { render, staticRenderFns } from "./AtmoInfoVoc.vue?vue&type=template&id=698327bc&scoped=true&"
var script = {}
import style0 from "./AtmoInfoVoc.vue?vue&type=style&index=0&id=698327bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698327bc",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('698327bc')) {
      api.createRecord('698327bc', component.options)
    } else {
      api.reload('698327bc', component.options)
    }
    module.hot.accept("./AtmoInfoVoc.vue?vue&type=template&id=698327bc&scoped=true&", function () {
      api.rerender('698327bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/integrations/templates/AtmoInfoVoc.vue"
export default component.exports